<template>
    <div class="tabs" v-responsive.lg.xl.md.sm>
        <div
                v-for="tentacle in tentacles"
                :id="`tab-${tentacle.urlSlug}`"
                :key="tentacle.id"
                @click="setTentacleType(tentacle)"
                class="tabs__btn"
                :class="{ active : type.id === tentacle.id }"
        >{{ tentacle.name }}
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'DashboardTabs',
  data() {
    return {
      userTentacles: [],
    };
  },
  watch: {
    $route(newOne, oldOne) {
      if (newOne.params.type) {
        this.loadTentacleType(this.getTypeByName(newOne.params.type));
      }
    },
  },
  computed: {
    ...mapGetters('tentacle', ['type', 'units', 'loading', 'tentacles']),
  },
  methods: {
    setTentacleType(tentacleType) {
      if (!this.loading) {
        this.$router.push({ name: 'dashboard', params: { lang: this.$i18n.locale.toLowerCase(), type: tentacleType.urlSlug } });
      }
    },
    getTypeByName(name) {
      return this.tentacles.find(item => item.urlSlug === name);
    },
    loadTentacleType(tentacleType) {
      if (this.units.length <= 1 || tentacleType.id !== this.type.id) {
          let customer = this.$store.getters['customer/customer'];
          let params = {customer: customer, type: tentacleType};
          this.$store.dispatch('tentacle/setType', params);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
    .tabs {
        display: flex;
        height: 8rem;
        width: 100%;
        align-items: flex-end;
        position: relative;
        z-index: 6;
        padding: 0 1rem;

        &__btn {
            height: 5rem;
            width: 10rem;
            margin-right: 0.5rem;
            border-radius: 1rem 1rem 0 0;
            background-color: $company-color;
            color: $white;
            font-size: 1.2rem;
            font-weight: 500;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.3s;
            box-shadow: 0px -1px 3px rgba(100, 116, 160, 0.1);

            &:hover {
                height: 5.4rem;
            }

            &.active {
                color: $dark;
                background-color: white;
                font-size: 1.3rem;
                width: 12rem;
                height: 6rem;
            }
        }
    }
</style>
